import React from 'react'
import s from './HomeHero.module.scss'

import Hero from 'assets/images/dogmented/hero.jpg'

export default function HomeHero(props) {
  return (
    <div className={s.home}> 
      <div className={s.img}>
        <img src={Hero} alt='Kia Dogmented Reality' />  
      </div>   
      <div className={s.content}>
        <h1 className={s.title}>Welcome to Robo<br />Dogmented Reality</h1>
        <p>Pet him, teach him tricks, and play with this fully charged pup in your very own home.</p>
        <div className={s.row}>
          <a href="/experience" className={s.button}>Play Now</a>  
        </div>
      </div>
    </div>
  );
}
